import type React from "react";

import {OverlayPortalProvider} from "@project/components/overlays/overlay-portal-context";
import {UNSAFE_PortalProvider} from "@react-aria/overlays";
import {useState} from "react";

interface ContentPortalBoundaryProps {
  children: React.ReactNode;
}

/**
 * ContentPortalBoundary — scopes app-owned overlays to the app content cell.
 *
 * Header, navigation, and extension chrome stay outside this boundary. Route
 * content stays inside it, so modals/dialogs rendered by pages fill only the
 * content area instead of the whole shell.
 */
export function ContentPortalBoundary({children}: ContentPortalBoundaryProps) {
  const [portalContainer, setPortalContainer] = useState<HTMLDivElement | null>(null);

  return (
    <div className="relative h-full min-h-0 w-full flex-1 overflow-hidden">
      <OverlayPortalProvider getContainer={() => portalContainer}>
        <UNSAFE_PortalProvider getContainer={() => portalContainer}>
          <div
            id="app-main-content"
            className="relative isolate flex h-full min-h-0 flex-col overflow-hidden"
          >
            {children}
          </div>

          <div
            ref={setPortalContainer}
            className="scoped-modal-portal pointer-events-none absolute inset-0 z-50"
          />
        </UNSAFE_PortalProvider>
      </OverlayPortalProvider>
    </div>
  );
}
